var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgAircraftModel = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 5,2 L 19,2 A 2,2 0 0,1 21,4 L 21,20 A 2,2 0 0,1 19,22 L 5,22 A 2,2 0 0,1 3,20 L 3,4 A 2,2 0 0,1 5,2",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M 12,4.58 C 12.54,4.58 12.91,5.11 12.91,5.81 L 12.91,8.07 L 16.3,10.01 L 16.3,11.08 L 12.91,10.11 L 12.91,12.05 L 13.99,12.91 L 13.99,13.82 L 12,13.29 L 10.01,13.82 L 10.01,12.91 L 11.09,12.05 L 11.09,10.11 L 7.7,11.08 L 7.7,10.01 L 11.09,8.07 L 11.09,5.81 C 11.09,5.12 11.46,4.58 12,4.58 L 12,4.58",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M 7,16.5 L 17,16.5",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M 7,19.2 L 13,19.2",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgAircraftModel, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/aircraft-model.a5ed8491.svg";
export { ForwardRef as ReactComponent };